<template>
    <div class="minimizeRight">
        <Card>
            <template #title>
                Select NSR
                <Button icon="pi pi-times" class="p-button-rounded p-button-secondary p-button-text"
                    style="position:fixed;right:10px" @click="close()" aria-label="Close" :disabled="disabled" />
                <!-- <Button icon="pi pi-window-minimize" class="p-button-rounded p-button-secondary p-button-text"
                    style="position:fixed;right:20px;top:10px;" v-if="minMode === false" @click="minimizeWin" />
                <Button icon="pi pi-window-maximize" class="p-button-rounded p-button-secondary p-button-text"
                    style="position:fixed;right:20px;top:10px;" v-if="minMode" @click="maximizeWin" /> -->
            </template>
            <template #content>
                <div class="formgrid grid">
                    <div class="field col-12">
                    </div>
                    <div class="field col-12 md:col-4">
                        <Button v-if="isAllModeReleased" label="Add NSR Point" icon="pi pi-plus"
                            @click="addNewNSRPoints" class="p-button-sm" style="margin: 0 5px;width:100%"
                            :disabled="!newNSRName || !newNSRCriteria || disabled" />
                    </div>
                    <div class="field col-12 md:col-4">
                        <Button v-if="isAllModeReleased" label="Move NSR Point" icon="pi pi-pencil"
                            @click="selectAndMoveNSRPoints" class="p-button-sm" style="margin: 0 5px;width:100%"
                            :disabled="disabled" />
                        <Button v-if="changeProjectNSRPointPositionMode" :label="changeProjectNSRPointButtonLabel"
                            icon="pi pi-pencil" @click="doneNSRBuildingPointsMove" class="p-button-sm"
                            style="background: darkgreen; background-color: darkgreen; margin: 0 5px;width:100%" />
                    </div>
                    <div class="field col-12 md:col-4">
                        <Button v-if="isAllModeReleased" label="Delete NSR Point" icon="pi pi-times"
                            @click="selectNSRPointsToDelete" class="p-button-sm" style="margin: 0 5px;width:100%"
                            :disabled="disabled" />
                        <Button :label="addPointNSRButtonLabel" icon="pi pi-pencil" @click="doneSelectNSRPointsToDelete"
                            class="p-button-sm"
                            style="background: darkgreen; background-color: darkgreen; margin: 0 5px;width:100%"
                            v-if="deleteNSRPointsMode" />
                    </div>
                    <div class="field col-12 md:col-12 fieldLabel" v-if="addNSRPointsMode">
                        Input NSR name and noise criteria before selecting the location on the map
                    </div>
                    <div class="field col-12 md:col-2 fieldLabel" v-if="addNSRPointsMode">
                        NSR Name:
                    </div>
                    <div class="field col-12 md:col-2" v-show="addNSRPointsMode">
                        <InputText type="text" v-model="newNSRName" autofocus style="width:100%"
                            :disabled="!addNSRPointsMode" ref="newNSRNameRef" />
                    </div>
                    <div class="field col-12 md:col-2 fieldLabel" v-if="addNSRPointsMode">
                        Noise Criteria:
                    </div>
                    <div class="field col-12 md:col-2" v-show="addNSRPointsMode">
                        <InputText type="text" v-model="newNSRCriteria" autofocus style="width:100%"
                            :disabled="!addNSRPointsMode" ref="newNSRCriteriaRef" />
                    </div>
                    <div class="field col-12 md:col-4">
                        <Button :label="addPointNSRButtonLabel" icon="pi pi-pencil" @click="doneAddNewNSRPoints"
                            class="p-button-sm"
                            style="background: darkgreen; background-color: darkgreen; margin: 0 5px;width:100%"
                            v-if="addNSRPointsMode" />
                    </div>
                    <!-- <div class="field col-12" style="text-align: left;">
                        Please recalculate after finishing modifying NSR points:
                    </div>
                    <div class="field col-12">
                        <Button :label="recalculating ? 'Calculating...' : 'Recalculate'" @click="recalculate"
                            class="p-button-sm" style="margin: 0 5px;width:100%" :disabled="disabled" />
                    </div> -->
                    <Divider></Divider>
                    <div class="field col-12" style="text-align: center;font-weight: bold;">
                        To select NSR points to include in Report, Hold CTRL + Drag mouse, to draw the selection
                        rectangle
                    </div>
                    <div class="field col-12" style="text-align: left;">The bigger size points
                        on
                        the map shows maximum 20 calculated sound power level on NSR.</div>
                    <div class="field col-12" style="text-align: left;">The residential and educational NSRs with
                        highest
                        CNLs will be auto-selected compulsorily and only the selected NSRs will be shown in the Report.
                    </div>
                    <DataTable :value="selectedNSRPoints" :scrollable="true" scrollHeight="45vh" style="width:100%"
                        editMode="row" @row-edit-save="onRowEditSave" v-model:editingRows="editingRows"
                        sortField="nsrName" :sortOrder="1">
                        <!-- <Column field="id" header="NSR ID" style="max-width:10%">
                        </Column> -->
                        <Column field="nsrName" header="NSR Name" style="max-width:20%">
                            <template #editor="{ data, field }">
                                <InputText type="text" v-model="data[field]" autofocus style="width:100%" />
                            </template>
                        </Column>
                        <Column field="buildingName" header="Building Name">
                            <template #editor="{ data, field }">
                                <InputText type="text" v-model="data[field]" autofocus style="width:100%" />
                            </template>
                        </Column>
                        <Column field="noisecriteria" header="Noise Criteria">
                            <template #editor="{ data, field }">
                                <InputText type="number" v-model="data[field]" autofocus style="width:100%" />
                            </template>
                        </Column>
                        <!-- <Column field="noiseCriteria" header="Noise Criteria" style="max-width:10%">
                        </Column> -->
                        <Column field="contributions" header="Noise Contribution from Neighbor Site">
                            <template #body="slotProps">
                                <div>
                                    <template v-for="contribution in slotProps.data.contributions">
                                        <div>{{ contribution.contributionText }}</div>
                                    </template>
                                </div>
                            </template>
                            <template #editor="{ data, field }">
                                <div class="formgrid grid">
                                    <Listbox v-model="selectedContribution" :options="data[field]"
                                        optionLabel="contributionText" emptyMessage="No Contribution"
                                        class="field col-12" />
                                    <Button label="Add" class="field col-12 md:col-5" style="height:30px"
                                        @click="showContributionWindow = true; editingRow = data"></Button>
                                    <div class="field col-12 md:col-2"></div>
                                    <Button label="Delete" class="field col-12 md:col-5" style="height:30px"
                                        :disabled="!selectedContribution" @click="deleteContribution(data)"></Button>
                                </div>
                            </template>
                        </Column>
                        <Column :rowEditor="true" style="max-width:80px;" bodyStyle="text-align:center"></Column>
                    </DataTable>
                </div>
            </template>
            <template #footer>
                <div class="formgrid grid" style="width:100%;">
                    <div class="field col-12 md:col-4">
                        <Button id="deselectbutton" label="Deselect" icon="pi pi-circle" @click="changeSelectionMode"
                            v-if="selectionMode === 1" style="width:100%" :disabled="disabled" />
                        <Button id="selectbutton" label="Select" icon="pi pi-circle-fill" @click="changeSelectionMode"
                            v-if="selectionMode === 0" style="width:100%" :disabled="disabled" />
                    </div>
                    <div class="field col-12 md:col-4">
                        <Button id="clearbutton" label="Clear Selection" icon="pi pi-trash" @click="clearSelection"
                            style="width:100%" :disabled="disabled" />
                    </div>
                    <div class="field col-12 md:col-4" v-if="!recalculating">
                        <Button id="donebutton" label="Save and Close" icon="pi pi-save" @click="doneSelect"
                            style="width:100%" :disabled="disabled" />
                    </div>
                    <div class="field col-12 md:col-4" v-if="recalculating">
                        <Button label="Recalculating..." icon="pi pi-spin pi-spinner" style="width:100%"
                            :disabled="disabled" />
                    </div>
                </div>
            </template>
        </Card>
    </div>
    <div id="DivAddCriteria" class="minimizeBottom" v-if="showContributionWindow">
        <Card>
            <template #title>
                Noise Contributed by Concurrent Sites
            </template>
            <template #content>
                <div class="formgrid grid">
                    <div class="field col-12 md:col-12">
                        <label style="width:100%;text-align: left;">Concurrent Site
                        </label>
                        <Dropdown id="criteriaSiteName" v-model="newContribution.name"
                            :options="project.unregisteredNeighbours" optionLabel="name" optionValue="name"
                            style="width:100%;height: 30px;text-align: left;">
                        </Dropdown>
                    </div>
                    <div class="field col-12 md:col-12">
                        <label for="criteriaStartDate" style="width:100%;text-align: left;">Commencement Date:</label>
                        <Calendar id="criteriaStartDate" v-model="newContribution.startDate" :showIcon="true"
                            class="w-full" dateFormat="yy-mm-dd" />
                    </div>
                    <div class="field col-12 md:col-12">
                        <label for="criteriaEndDate" style="width:100%;text-align: left;">End Date:</label>
                        <Calendar id="criteriaEndDate" v-model="newContribution.endDate" :showIcon="true" class="w-full"
                            dateFormat="yy-mm-dd" />
                    </div>
                    <div class="field col-12 md:col-12">
                        <label style="width:100%;text-align: left;">Noise Contribution:</label>
                        <InputNumber id="txtNCriteriaValue" v-model="newContribution.contribution" style="width:100%" />
                    </div>
                    <div class="field col-12 md:col-12"
                        style="flex-direction: row; display: flex; justify-content: space-between;">
                        <Button id="addbutton" label="Add" class="field fieldLabel" style="width:50px;height: 30px;"
                            @click="addContribution" />
                        <Button id="closeAddbutton" label="Close" class="field fieldLabel"
                            @click="showContributionWindow = false" style="width:50px;height: 30px;" />
                    </div>
                    <!-- <input type="hidden" id="critHiddenVal" />
                                                                                        <InputText id="textTest" v-model="testText" />
                                                                                        <Listbox v-model="selectedCity" :options="cities" optionLabel="name" /> -->
                </div>

            </template>
        </Card>
    </div>
    <div class="center" v-if="showAlert">
        <Card style="height:12vh">
            <template #title>
                Please include support documents for those moved/deleted NSR points in final report.
            </template>
            <template #content>
                <Button style="width:100px" label="Close" @click="showAlert = false"></Button>
            </template>
        </Card>
    </div>
</template>

<script>
import MapOL from "@/libs/myOpenLayers.js"

export default {
    name: 'SelectionView',
    data() {
        return {
            project: this.getCurrentProject(),

            activeIndex: 0,
            printMode: false,
            saving: "pi pi-angle-right",
            submitting: "pi pi-send",
            submitLabel: "Submit",

            supportMaterials: [],
            attachments: [],

            blobs: [],
            loading: true,

            selectionMode: 1,

            map: null,

            critProjectName: "",
            critStartDate: null,
            critEndDate: null,
            criteriaValue: 0,
            testText: "",

            mainWinHeigh: 69,
            mainWinTop: 15,
            minMode: false,

            selectedNSRPoints: [],
            editingRows: [],
            editingRow: null,
            selectedContribution: null,
            showContributionWindow: false,
            newContribution: {
                id: 0,
                name: "",
                startDate: null,
                endDate: null,
                contribution: 0,
                contributionText: "",
            },

            changeProjectNSRPointPositionMode: false,
            addNSRPointsMode: false,
            deleteNSRPointsMode: false,
            buttonLabelChangeProjectNSRPointOrDone: "Done",
            buttonLabelAddPointNSROrDone: "Done",
            buttonLabelDeletePointNSROrDone: "Done",

            newNSRName: "",
            newNSRCriteria: 70,

            recalculating: false,

            showAlert: false
        }
    },
    computed: {
        isReadonly() {
            return this.$store.getters.currentProject.readonly;
        },
        isTableVisible() {
            if (this.minMode) {
                return "none";
            }
            else {
                return "block";
            }
        },
        isAllModeReleased() {
            return this.changeProjectNSRPointPositionMode === false && this.addNSRPointsMode === false && this.deleteNSRPointsMode === false;
        },
        changeProjectNSRPointButtonLabel() {
            return this.buttonLabelChangeProjectNSRPointOrDone;
        },
        addPointNSRButtonLabel() {
            return this.buttonLabelAddPointNSROrDone;
        },
        deletePointNSRButtonLabel() {
            return this.buttonLabelDeletePointNSROrDone;
        },
        disabled() {
            return this.recalculating || !this.isAllModeReleased || this.editingRows.length > 0;
        }
    },
    methods: {
        getCurrentProject() {
            return this.$store.getters.currentProject;
        },
        close() {
            if (this.selectedNSRPoints.length) {
                this.doneSelect();
            }
            else {
                MapOL.changeNSRPointColorBackAfterSelection(this.selectedNSRPoints, false, null, true);
            }
            this.$router.replace({ path: '/' });
        },
        selectNSRPointsToReport() {
            MapOL.changeNSRPointColorForSelection();
        },
        doneSelect() {
            let props = this;
            props.recalculating = true;
            if (!props.selectedNSRPoints.length) {
                MapOL.changeNSRPointColorForSelection(function () { props.updateNSRPoints() }, function () {
                    MapOL.changeNSRPointColorBackAfterSelection(props.selectedNSRPoints, true, function () {
                        props.recalculating = false;
                        props.$router.replace({ path: '/' });
                    })
                });
            }
            else {
                MapOL.changeNSRPointColorBackAfterSelection(this.selectedNSRPoints, true, function () {
                    props.recalculating = false;
                    props.$router.replace({ path: '/' });
                });
            }
        },
        recalculate() {
            let props = this;
            props.recalculating = true;
            MapOL.changeNSRPointColorBackAfterSelection(this.selectedNSRPoints, true, function () {
                props.recalculating = false;
                MapOL.changeNSRPointColorForSelection(function () { props.updateNSRPoints() }, function () { props.updateNSRPoints() });
            });
        },
        clearSelection() {
            let props = this;
            MapOL.clearNSRPointColorBackSelection(function () {
                props.selectedNSRPoints = MapOL.getSelectedNSRPoints();
            });
        },
        changeSelectionMode() {
            if (this.selectionMode === 1) {
                this.selectionMode = 0;
                MapOL.changeNSRPointSelectionModeToDeselect();
            }
            else {
                this.selectionMode = 1;
                MapOL.changeNSRPointSelectionModeToSelect();
            }
        },
        onRowEditSave(event) {
            let { newData } = event;
            this.selectedNSRPoints[this.selectedNSRPoints.map(p => p.id).indexOf(newData.id)] = newData;
            this.selectedNSRPoints.forEach((p) => {
                p.feature.set("nsrname", p.nsrName)
                p.feature.set("BldName_E", p.buildingName)
                p.feature.set("noisecriteria", p.noisecriteria)
            })
        },
        addContribution() {
            this.editingRow.contributions.push({
                ...this.newContribution,
                contributionText: this.getContributionText(this.newContribution)
            });
            this.showContributionWindow = false;
            this.newContribution.id += 1;
        },
        deleteContribution(data) {
            data.contributions = data.contributions.filter(c => c.id != this.selectedContribution.id);
            this.selectedContribution = null;
        },
        getContributionText(contribution) {
            return `${contribution.name}@${contribution.startDate}~${contribution.endDate}: ${contribution.contribution}`
        },
        switchMode(mode) {
            this.changeProjectNSRPointPositionMode = false;
            this.addNSRPointsMode = false;
            this.deleteNSRPointsMode = false;

            switch (mode) {
                case 1:
                    this.addNSRBuildingMode = true;
                    break;
                case 2:
                    this.removeNSRBuildingMode = true;
                    break;
                case 3:
                    this.changeNoiseNSRBuildingMode = true;
                    break;
                case 4:
                    this.changeProjectNSRPointPositionMode = true;
                    break;
                case 5:
                    this.addNSRPointsMode = true;
                    break;
                case 6:
                    this.deleteNSRPointsMode = true;
                    break;
                default:
            }
        },
        switchButtonLabel(index, textLabel) {
            if (index === 1) {
                this.buttonLabelAddNSRProcessingOrDone = textLabel;
            }
            else if (index === 2) {
                this.buttonLabelRemoveNSRProcessingOrDone = textLabel;
            }
            else if (index === 3) {
                this.buttonLabelChangeNoiseProcessingOrDone = textLabel;
            }
            else if (index === 4) {
                this.buttonLabelChangeProjectNSRPointOrDone = textLabel;
            }
            else if (index === 5) {
                this.buttonLabelAddPointNSROrDone = textLabel;
            }
            else if (index === 6) {
                this.buttonLabelDeletePointNSROrDone = textLabel;
            }

        },
        // move nsr point
        selectAndMoveNSRPoints() {
            this.switchMode(4);
            MapOL.changeNSRPointColorBackAfterSelection(this.selectedNSRPoints, false);
            MapOL.moveNSRBuildingPoints(this.addNSRHistory);
            console.log(MapOL.getHighestNoiseNSRIds())
        },
        doneNSRBuildingPointsMove() {
            let props = this;
            const isHighestNoiseNSRMoved = MapOL.isHighestNoiseNSRMoved();
            this.switchButtonLabel(4, "Processing... Please wait.");
            MapOL.processMoveNSRBuildingPoints(function () {
                props.recalculate();
                props.switchButtonLabel(4, "Done");
                props.switchMode(-1);
                props.showAlert = isHighestNoiseNSRMoved;
            });
        },
        // add nsr point
        addNewNSRPoints() {
            this.switchMode(5);
            MapOL.changeNSRPointColorBackAfterSelection(this.selectedNSRPoints, false);
            MapOL.addNewNSRPoints(this.project.id, this.$refs.newNSRNameRef, this.$refs.newNSRCriteriaRef);
        },
        doneAddNewNSRPoints() {
            let props = this;
            this.switchButtonLabel(5, "Processing... Please wait.");
            MapOL.processAddNewNSRPoints(function () {
                props.recalculate();
                props.switchButtonLabel(5, "Done");
                props.switchMode(-1);
            }, this.newNSRName, this.newNSRCriteria);
            this.newNSRName = `N${Number(this.newNSRName.replace('N', '')) + 1}`;
        },
        // delete nsr point
        selectNSRPointsToDelete() {
            this.switchMode(6);
            MapOL.changeNSRPointColorBackAfterSelection(this.selectedNSRPoints, false);
            MapOL.removeNSRPoints();
        },
        doneSelectNSRPointsToDelete() {
            let props = this;
            const isHighestNoiseNSRDeleted = MapOL.isHighestNoiseNSRDeleted();
            this.switchButtonLabel(6, "Processing... Please wait.");
            MapOL.processRemoveNSRPoints(this.project.id, props.addNSRHistory, function () {
                props.recalculate();
                props.switchButtonLabel(6, "Done");
                props.switchMode(-1);
                props.showAlert = isHighestNoiseNSRDeleted;
            });
        },
        updateNSRPoints() {
            let props = this;
            props.selectedNSRPoints = MapOL.getSelectedNSRPoints();
            const numbers = this.selectedNSRPoints.map(p => Number(p.nsrName ? p.nsrName.replace('N', '') : '0')).filter(n => n);
            this.newNSRName = `N${(numbers.length ? Math.max(...numbers) : 0) + 1}`;
        },
        addNSRHistory(feature) {
            let props = this;
            if (feature.get("initCoords")) {
                this.axios
                    .post(`${this.apiEndpoint}projectnsrpointhistory`, [{
                        id: typeof feature.getId() == "string" ? feature.getId().replace("projectNSRPoints.", "") : feature.getId(),
                        projectId: props.$store.getters.ProjectId,
                        oldx: feature.get("initCoords")[0],
                        oldy: feature.get("initCoords")[1],
                        x: feature.getGeometry().getCoordinates()[0],
                        y: feature.getGeometry().getCoordinates()[1],
                        isClosest: MapOL.getHighestNoiseNSRIds().includes(feature.id),
                        nsrname: feature.get("nsrname") || "",
                        buildingName: feature.get("buildingName") || feature.get("BldName_E") || "",
                    }])
                    .catch(error => { console.log(error) })
            }
        }
    },
    beforeMount() {
        this.map = MapOL.getMapCanvas();
    },
    mounted() {
        MapOL.setSelectedNSRPointsIDState();
        MapOL.changeNSRPointColorForSelection(this.updateNSRPoints);
        this.selectedNSRPoints = MapOL.getSelectedNSRPoints();
        if (this.project.unregisteredNeighbours.length > 0) {
            this.newContribution.name = this.project.unregisteredNeighbours[0].name;
        }
        this.newContribution.startDate = this.project.commencementDate;
        this.newContribution.endDate = this.project.completionDate;
        const numbers = this.selectedNSRPoints.map(p => Number(p.nsrName ? p.nsrName.replace('N', '') : '0')).filter(n => n);
        this.newNSRName = `N${(numbers.length ? Math.max(...numbers) : 0) + 1}`;
    }
}
</script>

<style scoped>
.minimizeRight {
    width: 35vw;
    position: absolute;
    transform: translate(calc(65vw - 10px), 0%);
    top: 10px;
    max-height: 70vh;
}

.minimizeBottom {
    width: 15vw;
    position: absolute;
    transform: translate(510%, 0%);
    top: 15vh;
    overflow: hidden;
}

.center {
    width: 20vw;
    position: absolute;
    transform: translate(72.5vw, 0%);
    top: 15vh;
}
</style>